import React, { Component } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import Tabs from "./Tabs.js";
import Icon from "./Icon.js";
const RETURN_URLS = {
    'deveducation.gi.org': 'https://deveducation.gi.org',
    'education.gi.org': 'https://education.gi.org'
};
const returnUrl = RETURN_URLS[window.location.hostname] || 'https://education.gi.org';
const loginUrl = 'https://accounts.gi.org/?returnUrl=' + returnUrl;
class Login extends Component {
    constructor (props) {
        super(props);
        this.state = {
        }
    }
    componentDidMount() {
    }
    render() {
        return (
            <>
                <Tabs authenticated={false} user="anonymous"/>
                <div class="row align-items-center m-t-lg">
                    <div class="col-md-6 col-xs-12 p-lg-r-md">
                        <a href={loginUrl} class="btn btn-primary btn-lg" data-feathr-click-track="true">Click here to login</a>
                    </div>
                    <div class="col-md-6 col-xs-12 p-lg-l-md">
                        <h3 class="text-xl text-muted m-b">Join ACG, one of the leading organizations for clinical gastroenterologists.</h3>
                        <p>More than 21,000 GI professionals in the U.S. and worldwide call themselves an ACG Member. Join the community of clinical gastroenterologists committed to providing quality in patient care. ACG Members gain access to a wide variety of exclusive resources and benefit from ACG’s ongoing educational and legislative initiatives to ensure quality in care. Learn about ACG’s educational programs, physician resources,  <em>The American Journal of Gastroenterology</em>, much more. </p>
                        <p><a href="https://members.gi.org/acgmembership/" class="btn btn-success" data-feathr-click-track="true">Become a Member</a></p>
                    </div>
                </div>
            </>
        );
    }
}

export default Login;
